import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("smipl_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("smipl_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("smipl_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("smipl_token");
      localStorage.removeItem("smipl_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (mobile, password) => {
    const r = await api.post("/auth/login", { mobile, password });
    localStorage.setItem("smipl_token", r.data.access_token);
    localStorage.setItem("smipl_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("smipl_token");
    localStorage.removeItem("smipl_user");
    setUser(null);
    window.location.href = "/login";
  };
  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("smipl_user", JSON.stringify(r.data));
      return r.data;
    } catch { return null; }
  };
  return <AuthCtx.Provider value={{ user, login, logout, loading, refreshUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const hasRole = (user, ...roles) => user && roles.includes(user.role);
